import { render } from "./GalleryDetail.vue?vue&type=template&id=bbef165c&scoped=true"
import script from "./GalleryDetail.vue?vue&type=script&lang=js"
export * from "./GalleryDetail.vue?vue&type=script&lang=js"

import "./GalleryDetail.vue?vue&type=style&index=0&id=bbef165c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbef165c"]])

export default __exports__